import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Clock } from 'lucide-react';
import { RootState } from '../../configuration';
import { Post } from '../../components/post/post.component';
import Loading from '../../components/loading/loading.component';
import { fetchPublicPostsByCategory } from '../../api/posts/fetch-post.api';

// Danh mục "Hoài niệm (Cab cũ)" — seed cố định ở post-service.
const HOAI_NIEM_CATEGORY_ID = '01dcab00-0000-0000-0000-000000000001';
const PAGE_SIZE = 10;
// Gỡ đuôi thương hiệu "... | Cab.vn - Cộng đồng Meme..." còn sót trong caption bài cũ.
const cleanCap = (s?: string) =>
  (s ?? '').split(/\s*[|\-–]\s*cab\.vn/i)[0].trim();
const BRAND = '#066BFF';

export const OldPage = () => {
  const profile = useSelector((s: RootState) => s.features.auth.profile);
  const [posts, setPosts] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetchPublicPostsByCategory({
          categoryId: HOAI_NIEM_CATEGORY_ID,
          pageNumber: page,
          pageSize: PAGE_SIZE,
          userId: profile?.userId,
        });
        const data = (res?.data ?? []).map((p: any) => ({
          ...p,
          content: cleanCap(p.content),
          title: cleanCap(p.title),
        }));
        if (cancelled) return;
        setPosts((prev) => (page === 1 ? data : [...prev, ...data]));
        setHasMore(data.length >= PAGE_SIZE);
      } catch (e) {
        if (!cancelled) setHasMore(false);
      } finally {
        if (!cancelled) setFirstLoad(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [page, profile?.userId]);

  return (
    <div className="max-w-2xl mx-auto px-3 py-4">
      {/* Banner hoài niệm */}
      <div className="ui-card rounded-2xl overflow-hidden mb-5">
        <div
          className="px-5 py-6 text-white"
          style={{ background: `linear-gradient(135deg, ${BRAND} 0%, #00b3b3 100%)` }}
        >
          <div className="flex items-center gap-2 text-xs uppercase tracking-wide opacity-90">
            <Clock size={14} /> 2011 – 2014
          </div>
          <h1 className="text-2xl font-bold mt-1">Cab xưa · Hoài niệm</h1>
          <p className="text-sm opacity-95 mt-1">
            Phục dựng kho meme & ragecomics thời đầu của Cab.vn từ kho lưu trữ. Xem thoải
            mái — thích/bình luận thì đăng nhập nhé.
          </p>
        </div>
      </div>

      {/* Feed bài Hoài niệm */}
      {firstLoad ? (
        <Loading classname="mx-auto" />
      ) : posts.length === 0 ? (
        <p className="ui-muted text-center py-10">
          Chưa có bài nào được duyệt. Quay lại sau nhé!
        </p>
      ) : (
        <InfiniteScroll
          dataLength={posts.length}
          next={() => setPage((p) => p + 1)}
          hasMore={hasMore}
          loader={<Loading classname="mx-auto" />}
        >
          <div className="space-y-6">
            {posts.map((post) => (
              <Post key={post.id} post={post} />
            ))}
          </div>
        </InfiniteScroll>
      )}
    </div>
  );
};

export default OldPage;
